import '../scss/home.scss';
import { instagramPopup } from '../components/instagram-section';
import { lazyLoad } from '../utils/lazy-load';
import { $Q, $Qll } from '../utils/query-selector';

lazyLoad($Q('.js-instagram'), (observe) => {
  const postsContainer = $Qll('#js-instagram-posts .instagram__post')

  if (!postsContainer.length) {
    instagramPopup()
    observe.disconnect()
  } else observe.disconnect()
}, {
  rootMargin: '300px',
  threshold: 0,
})
